import { SeqLoggingTokenService } from './SeqLoggingTokenService';
let errorQueue: any[] = [];
const errorUnique = <any> {}; // This could leak memory. However, if it does, something is wrong that needs to be fixed.
const NEXT_ITEM_TIMEOUT = 1000;
const ERROR_LIMIT = 10000;
let hitLimit = false;
let loggingInProgress = false;
function log(exception: Error, cause: any, token: string) {
    // const payload = {
    //     "@t": (new Date).toISOString(),
    //     "@mt": `Exception on {Application}, {Context}`,
    //     "@l": "Exception",
    //     Application: document.location.href,
    //     Context: document.location,
    //     "@x": exception.stack,
    // };
    // console.error('logging exception', payload);
    const nextLog = () => {
        const nextException = <any> errorQueue[0];
        errorQueue.unshift();
        if (nextException) {
            const error = {
                method: 'post',
                body: JSON.stringify({
                    exception: nextException.stack,
                    message: nextException.message,
                    token,
                }),
            };
            if (!errorUnique[error.body]) {
                // already reported!
                console.error('logging exception', nextException, nextException.message);
                fetch('/SeqLogging/exception', error);
            }
            errorUnique[error.body] = true;
        }
        // Considered using debounce BUT want to log every error!
        if (errorQueue.length) {
            setTimeout(nextLog, NEXT_ITEM_TIMEOUT);
        } else {
            loggingInProgress = false;
        }
    };
    if (errorQueue.length > ERROR_LIMIT) {
        if (hitLimit) {
            return;
        }
        console.error('Error limit reached! Please contact a developer!');
        hitLimit = true;
        return;
    } else {
        hitLimit = false;
    }
    errorQueue.push(exception);
    if (errorQueue.length && !loggingInProgress) {
        loggingInProgress = true;
        setTimeout(nextLog, NEXT_ITEM_TIMEOUT);
    }
}
export const logErrorsToBackendFactory = ['$http', function ($http: ng.IHttpService) {
    console.info(`Logging errors with Seq (Serilog) raw endpoint. @see seq_error_logger.ts`)
    return {
        $get: () => {
            console.warn(`$get called (Seq error logging)`);
        }
    }
}];
export class ExceptionProvider {
    public static $inject = ['seqLoggingTokenService'];
    constructor(
        private seqLoggingTokenService: SeqLoggingTokenService,
    ) {

    }
}
export const exceptionHandlerFactory = [
    '$log',
    'seqLoggingTokenService',
    ($log, seqLoggingTokenService: SeqLoggingTokenService) => {
		console.log('Error logging to Seq enabled');
        function myExceptionHandler(exception, cause) {
            seqLoggingTokenService.getToken().then(token => {
                log(exception, cause, token);
            });
            $log.error(exception, cause);
        };
		// window.onerror = myExceptionHandler;
		return myExceptionHandler;
    }];
